import { intersection } from 'd3';

import { type CompanyId, type Permissions, ResourceId } from 'common/api/api-types';
import useUserPermissions from 'common/hooks/useUserPermissions';

type Props = React.PropsWithChildren<{
  companyId?: CompanyId;
  fallback?: React.ReactNode;
  required?: Permissions;
}>;

const isTypeResourceId = (resourceId: string): resourceId is ResourceId =>
  ResourceId.safeParse(resourceId).success;

export const AccessControl: React.FunctionComponent<Props> = ({
  children,
  companyId,
  fallback,
  required,
}) => {
  const { isEnabled, isPending, data } = useUserPermissions({ companyId });

  if (!isEnabled) {
    return fallback;
  }

  if (isPending) {
    return null;
  }

  const resources = Object.entries(required ?? {});

  if (
    data &&
    resources.length > 0 &&
    resources.every(([resourceId, permissions]) => {
      if (!isTypeResourceId(resourceId) || permissions.size === 0) {
        return false;
      }

      return (
        intersection(permissions, data.permissions?.[resourceId] ?? new Set()).size ===
        permissions.size
      );
    })
  ) {
    return children;
  }

  return fallback;
};
